import { css } from 'styled-components'

// NOTE: Please use styles/index.js for font-size, width, height, etc

const breakPoints = {
  desktop: '1023px',
}

const colors = {
  white: '#fff',
  lightGrey: '#f6f6f6',
  mediumGrey: '#e0dedf',
  grey: '#a2a2a2',
  darkerGrey: '#7a7a7a',
  darkGrey: '#2b2b2b',
  lightBlack: '#20211a',
  black: '#000',
  lightBlue: '#e8ebf3',
  blue: '#22398b',
  green: '#5a813a',
  darkGreen: '#303b35',
  pink: '#eabfbb',
  yellow: '#ffe05a',
  orange: '#ee8c02',
  burntOrange: '#D86A39',
  daily: '#c53341',
  travel: '#3a46d4',
  medical: '#685e89',
  skiing: '#e3e14a',
  outdoor: '#00945f',
  sports: '#ea6227',
}

const space = {
  marginDesktop: '0.69',
  marginMobile: '4',
}

const fontFamily = {
  normal: 'MaisonNeueBook, Arial, sans-serif',
  medium: 'MaisonNeueMedium, Arial, sans-serif',
  bold: 'MaisonNeueBold, Arial, sans-serif',
}

const fontSize = {
  m12: '1.6vw',
  m18: '2.4vw',
  m20: '2.666666667vw',
  m23: '3.066666667vw',
  m26: '3.466666667vw', // 13px
  m30: '4vw',
  m35: '4.667vw',
  m40: '5.33333333vw',
  m50: '14.286vw',
  d11: '0.76vw',
  d12: '0.83vw',
  d14: '0.97vw',
  d15: '1.04vw',
  d20: '1.39vw',
  d25: '1.74vw',
  d30: '2.08vw',
  d35: '2.43vw',
  d40: '2.78vw',
  d50: '3.47vw',
}

const headerHeight = {
  mobile: '13.0666666667vw',
  desktop: '6.9vw',
}

const announcementHeight = {
  mobile: '9vw',
  desktop: '2vw',
}

const fullHeightWithHeader = {
  mobile: 'calc(100vh - 13.0666666667vw)',
  desktop: 'calc(100vh - 6.9vw)',
}

const fullHeightWithFullHeader = {
  mobile: 'calc(100vh - 13.0666666667vw - 9vw)',
  desktop: 'calc(100vh - 6.9vw - 2vw)',
}

const easeInOut = {
  sine: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
  quad: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
  cubic: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
  quart: 'cubic-bezier(0.77, 0, 0.175, 1)',
  quint: 'cubic-bezier(0.86, 0, 0.07, 1)',
  expo: 'cubic-bezier(1, 0, 0, 1)',
}

const easeIn = {
  sine: 'cubic-bezier(0.47, 0, 0.745, 0.715)',
  quad: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
  cubic: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
  quart: 'cubic-bezier(0.895, 0.03, 0.685, 0.22)',
  quint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
  expo: 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
}

const easeOut = {
  sine: 'cubic-bezier(0.39, 0.575, 0.565, 1)',
  quad: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  cubic: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
  quart: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
  quint: 'cubic-bezier(0.23, 1, 0.32, 1)',
  expo: 'cubic-bezier(0.19, 1, 0.22, 1)',
}

const theme = {
  breakPoints,
  colors,
  space,
  fontFamily,
  fontSize,
  headerHeight,
  fullHeightWithHeader,
  fullHeightWithFullHeader,
  announcementHeight,
  easeInOut,
  easeIn,
  easeOut,

  underline: (color, letterSpacing) => css`
    &::after {
      content: '';
      display: block;
      margin-top: 2px;
      height: 1px;
      background: ${color};
      transform: scaleX(0);
      transition: none;
      transform-origin: left;
      margin-right: ${letterSpacing};
    }
    &:hover::after {
      transform: scaleX(1);
      transition: transform 0.2s ease-out;
    }
  `,
}

export default theme
